import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import BannerGallery from "./BannerGallery";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import linkedin from "../../assets/linkedin.svg";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState({
    isSubmitting: false,
    isSuccess: false,
    error: null
  });

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (formData.name.length < 2) {
      newErrors.name = "Name must be at least 2 characters long";
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (formData.message.length < 10) {
      newErrors.message = "Message must be at least 10 characters long";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
    
    // Clear error when user starts typing
    if (errors[id]) {
      setErrors(prev => ({
        ...prev,
        [id]: null
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    
    if (!validateForm()) {
      return;
    }

    setSubmitStatus({ isSubmitting: true, isSuccess: false, error: null });

    try {
      const res = await fetch('https://formspree.io/f/mzbnjbjk', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!res.ok) {
        throw new Error('Failed to send message');
      }

      setSubmitStatus({ isSubmitting: false, isSuccess: true, error: null });
      setFormData({ name: "", email: "", message: "" });
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(prev => ({ ...prev, isSuccess: false }));
      }, 5000);

    } catch (error) {
      setSubmitStatus({ 
        isSubmitting: false, 
        isSuccess: false, 
        error: "Failed to send message. Please try again later."
      });
    }
  };

  return (
    <div className="page pt-20">
      <Navbar />
      <BannerGallery />
      <div>
        <div className="flex flex-col gap-16 md:gap-10 px-10 py-20">
          <p className="uppercase text-[2rem] font-[600]">Need help with an idea? Let's chat!</p>
          <div className="flex flex-col md:flex-row gap-5 md:gap-10">
            <div className="w-full md:w-1/3 flex flex-col gap-2">
              <p className="uppercase">Contact information</p>
              <p></p>
            </div>
            <div className="w-full md:w-2/3 flex flex-row gap-16 items-center">
              <div className="flex flex-row gap-3">
                <a
                  href="https://dribbble.com/maye_tech"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    className="main-grid-item-icon"
                    fill="none"
                  >
                    <path
                      clipRule="evenodd"
                      d="M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0Zm7.926 5.531a10.202 10.202 0 0 1 2.317 6.378c-.338-.065-3.722-.755-7.132-.325-.079-.17-.144-.352-.222-.534a30.535 30.535 0 0 0-.676-1.484c3.774-1.536 5.492-3.748 5.713-4.035ZM12 1.771c2.603 0 4.985.975 6.794 2.576-.182.26-1.731 2.33-5.375 3.696-1.68-3.084-3.54-5.61-3.827-6A10.424 10.424 0 0 1 12 1.77Zm-4.36.962c.273.365 2.095 2.903 3.8 5.922-4.79 1.276-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172Zm-5.896 9.28v-.312c.443.013 5.414.078 10.53-1.458.299.573.572 1.158.832 1.744-.13.039-.273.078-.403.117-5.284 1.705-8.096 6.364-8.33 6.755a10.226 10.226 0 0 1-2.629-6.846ZM12 22.256c-2.369 0-4.555-.807-6.286-2.16.182-.378 2.264-4.387 8.043-6.404.026-.013.04-.013.065-.026 1.445 3.735 2.03 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82Zm5.714-1.757c-.104-.625-.651-3.618-1.992-7.302 3.215-.507 6.026.326 6.378.443-.443 2.85-2.083 5.31-4.386 6.859Z"
                      fill="#EA4C89"
                      fillRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/mary-ojo/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} className="w-6" alt=""/>
                </a>
              </div>
              <div className="flex flex-row items-center gap-2">
                <a href="mailto:hi@maryojo.me">hi@maryojo.me</a>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-5 md:gap-10">
            <div className="w-full md:w-1/3 flex flex-col gap-2">
              <p className="uppercase">Send Me a message</p>
              <p></p>
            </div>
            <form onSubmit={handleSubmit} className="w-full md:w-2/3">
              {submitStatus.isSuccess && (
                <div className="mb-6 bg-green-50 text-green-800 border-green-200 p-3">
                  <p>Message sent successfully! Thank you for reaching out.</p>
                </div>
              )}

              {submitStatus.error && (
                <div className="mb-6">
                  <svg
                    className="h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-circle-alert"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" x2="12" y1="8" y2="12" />
                    <line x1="12" x2="12.01" y1="16" y2="16" />
                  </svg>
                  <p>{submitStatus.error}</p>
                </div>
              )}

              <div className="mb-6">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  What's your name?
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className={`block w-full border-0 bg-transparent border-b-[1px] ${
                    errors.name ? "border-red-300" : "border-gray-300"
                  } focus:border-blue-500 focus:ring-0 focus:outline-none p-2`}
                  placeholder="Enter your name"
                />
                {errors.name && (
                  <p className="mt-1 text-sm text-red-300">{errors.name}</p>
                )}
              </div>

              <div className="mb-6">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  What's your email?
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={`block w-full bg-transparent border-0 border-b-[1px] ${
                    errors.email ? "border-red-300" : "border-gray-300"
                  } focus:border-blue-500 focus:ring-0 focus:outline-none p-2`}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-300">{errors.email}</p>
                )}
              </div>

              <div className="mb-6">
                <label
                  htmlFor="message"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className={`block w-full border-0 bg-transparent border-b-[1px] ${
                    errors.message ? "border-red-300" : "border-gray-300"
                  } focus:border-blue-500 focus:ring-0 focus:outline-none p-2`}
                  placeholder="Enter your message"
                ></textarea>
                {errors.message && (
                  <p className="mt-1 text-sm text-red-300">{errors.message}</p>
                )}
              </div>

              <div className="uppercase flex flex-row gap-3 items-center">
                <button
                  type="submit"
                  disabled={submitStatus.isSubmitting}
                  className="font-semibold text-xl flex items-center gap-2 bg-transparent px-0"
                >
                  {submitStatus.isSubmitting ? "Sending..." : "Send message"}
                  <Button />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;